export const API_KEY = "AIzaSyC2UaIgFUBDbtlU0nDQv8ExLrIoL3w3oAo";

// The Google API key was created from this link:
// https://developers.google.com/custom-search/v1/using_rest

// 1. Click on identify your application
// 2. Click on get key
// 3. Select your application to associate your API Key and select next
// 4. Copy the API key

// Next, visit the following link:
// https://cse.google.com/cse/create/new

// 1. Enter www.google.com in the sites to search textbox
// 2. click the create button
// 3. select setup from the menu on the left and turn on search the entire web
// 4. copy the search engine id



export default API_KEY;

